/**
 * What a new lock costs, for the page's FREE mark (lock redesign, Bez 2026-10-09: "the service being FREE must be bold"). Pure: it only
 * reads the live fee reads of the lockers (fees.ts, unchanged). "Free" is said only when every locker asked answers 0 BNB and 0 CBON;
 * any non-zero price shows the lowest price instead, and a read that has not answered keeps the space without claiming anything.
 */
import type { Fees } from '../fees'

export type PriceState =
  | { kind: 'free' }
  | { kind: 'priced'; native?: bigint; cbon?: bigint }
  | { kind: 'loading' }
  | { kind: 'unknown' }

const lowest = (xs: Array<bigint | undefined>) =>
  xs
    .filter((x): x is bigint => x !== undefined && x > 0n)
    .reduce<bigint | undefined>((m, x) => (m === undefined || x < m ? x : m), undefined)

export function priceOf(...lockers: Fees[]): PriceState {
  if (lockers.length === 0) return { kind: 'unknown' }
  const priced = lockers.some((f) => (f.native !== undefined && f.native > 0n) || (f.cbon !== undefined && f.cbon > 0n))
  if (priced)
    return { kind: 'priced', native: lowest(lockers.map((f) => f.native)), cbon: lowest(lockers.map((f) => f.cbon)) }
  if (lockers.every((f) => f.native === 0n && f.cbon === 0n)) return { kind: 'free' }
  if (lockers.some((f) => f.loading && (f.native === undefined || f.cbon === undefined))) return { kind: 'loading' }
  return { kind: 'unknown' }
}
